import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  SimpleGrid,
  Image,
  Flex,
  Heading,
  Text,
  Stack,
  StackDivider,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import happy_img from 'assets/happy_writing.jpeg';

const Feature = ({ text, icon, iconBg }) => {
  return (
    <Stack direction={'row'} align={'center'}>
      <Flex
        w={8}
        h={8}
        align={'center'}
        justify={'center'}
        rounded={'full'}
        bg={iconBg}
      >
        {icon}
      </Flex>
      <Text fontWeight={600}>{text}</Text>
    </Stack>
  );
};

Feature.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.any,
  iconBg: PropTypes.any,
};

export default function WhyChooseUs() {
  return (
    <Container maxW={'6xl'} py={12}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        <Stack spacing={4}>
          <Text
            textTransform={'uppercase'}
            color={'blue.400'}
            fontWeight={600}
            fontSize={'sm'}
            bg={useColorModeValue('blue.50', 'blue.900')}
            p={2}
            alignSelf={'flex-start'}
            rounded={'md'}
          >
            Why choose us
          </Text>
          <Heading fontSize={{ base: 'xl', sm: '2xl' }} fontWeight={'bold'}>
            Empowering Students to Write with Confidence
          </Heading>
          <Text color={'gray.500'} fontSize={'lg'}>
            At Dynivy Academy, writing becomes a skill students love to master.
            Our platform turns the writing process into an engaging,
            personalized, and rewarding experience.
          </Text>
          <Stack
            spacing={4}
            divider={
              <StackDivider
                borderColor={useColorModeValue('gray.100', 'gray.700')}
              />
            }
          >
            <Feature
              icon={<Icon as={CheckIcon} color={'green.500'} w={5} h={5} />}
              iconBg={useColorModeValue('green.100', 'green.900')}
              text={
                'Boost creativity and confidence with tools that unlock student’s potential'
              }
            />
            <Feature
              icon={<Icon as={CheckIcon} color={'green.500'} w={5} h={5} />}
              iconBg={useColorModeValue('green.100', 'green.900')}
              text={
                'Get personalized support that adapts to student’s learning needs in real-time'
              }
            />
            <Feature
              icon={<Icon as={CheckIcon} color={'green.500'} w={5} h={5} />}
              iconBg={useColorModeValue('green.100', 'green.900')}
              text={
                'Make writing fun with interactive games and challenges that engage students'
              }
            />
            <Feature
              icon={<Icon as={CheckIcon} color={'green.500'} w={5} h={5} />}
              iconBg={useColorModeValue('green.100', 'green.900')}
              text={
                'Track progress and set goals easily with friendly dashboards'
              }
            />
          </Stack>
        </Stack>
        <Flex display={'block'}>
          <Image
            rounded={'md'}
            alt={'feature image'}
            src={happy_img}
            objectFit={'cover'}
          />
        </Flex>
      </SimpleGrid>
    </Container>
  );
}
